import type { TextStyle } from "react-native";

import { fontSizes, lineHeights } from "@indeed/ifl-tokens/react-native";

export type TextLevel = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
export const TEXT_LEVELS = [1, 2, 3, 4, 5, 6, 7, 8];

const FONT_SIZES: Record<number, TextStyle> = {
  1: {
    fontSize: fontSizes.f1,
    lineHeight: fontSizes.f1 * lineHeights.normal,
  },
  2: {
    fontSize: fontSizes.f2,
    lineHeight: fontSizes.f2 * lineHeights.normal,
  },
  3: {
    fontSize: fontSizes.f3,
    lineHeight: fontSizes.f3 * lineHeights.normal,
  },
  4: {
    fontSize: fontSizes.f4,
    lineHeight: fontSizes.f4 * lineHeights.normal,
  },
  5: {
    fontSize: fontSizes.f5,
    lineHeight: fontSizes.f5 * lineHeights.tight,
  },
  6: {
    fontSize: fontSizes.f6,
    lineHeight: fontSizes.f6 * lineHeights.tight,
  },
  7: {
    fontSize: fontSizes.f7,
    lineHeight: fontSizes.f7 * lineHeights.tight,
  },
  8: {
    fontSize: fontSizes.f8,
    lineHeight: fontSizes.f8 * lineHeights.tight,
  },
};

type Theme = {
  fontSizes: {
    f1: number;
    f2: number;
    f3: number;
    f4: number;
    f5: number;
    f6: number;
    f7: number;
    f8: number;
  };
  lineHeights: {
    normal: number;
    tight: number;
  };
};

/**
 * line heights: https://experience.indeed.design/fundamentals/ids/design-typography#line-heights
 */
function createFontSizes(theme: Theme): Record<number, TextStyle> {
  return {
    1: {
      fontSize: theme.fontSizes.f1,
      lineHeight: theme.fontSizes.f1 * theme.lineHeights.normal,
    },
    2: {
      fontSize: theme.fontSizes.f2,
      lineHeight: theme.fontSizes.f2 * theme.lineHeights.normal,
    },
    3: {
      fontSize: theme.fontSizes.f3,
      lineHeight: theme.fontSizes.f3 * theme.lineHeights.normal,
    },
    4: {
      fontSize: theme.fontSizes.f4,
      lineHeight: theme.fontSizes.f4 * theme.lineHeights.normal,
    },
    5: {
      fontSize: theme.fontSizes.f5,
      lineHeight: theme.fontSizes.f5 * theme.lineHeights.tight,
    },
    6: {
      fontSize: theme.fontSizes.f6,
      lineHeight: theme.fontSizes.f6 * theme.lineHeights.tight,
    },
    7: {
      fontSize: theme.fontSizes.f7,
      lineHeight: theme.fontSizes.f7 * theme.lineHeights.tight,
    },
    8: {
      fontSize: theme.fontSizes.f8,
      lineHeight: theme.fontSizes.f8 * theme.lineHeights.tight,
    },
  };
}

export function getFontSizeStyle(level: TextLevel, theme?: Theme): TextStyle {
  if (theme) {
    const fontSizes = createFontSizes(theme);
    return fontSizes[level];
  } else {
    return FONT_SIZES[level];
  }
}
